/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Discount_PercentInputs */

const vi_order_discount_percent = /** @type {(inputs: Order_Discount_PercentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiết khấu đơn hàng`)
};

/**

* @param {Order_Discount_PercentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_discount_percent = /** @type {((inputs?: Order_Discount_PercentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Discount_PercentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_discount_percent(inputs)
});